import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";
import TextField from "./TextField";

const onFormattedChange = (changeFunc, fieldName) => values =>
    changeFunc({ target: { name: [fieldName], value: values.value || 0 } });

const NumberField = props => {
    const { inputRef, onChange, name, ...other } = props;
    return (
        <NumberFormat
            allowNegative={false}
            getInputRef={inputRef}
            onValueChange={onFormattedChange(onChange, name)}
            {...other}
        />
    );
};

const styles = {
    root: {
        "& input[type=number]::-webkit-inner-spin-button,& input[type=number]::-webkit-outer-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
        },
        "& input[type=number]": {
            MozAppearance: "textfield",
        },
    },
};

const CustomNumberField = props => {
    const { disabled, ...rest } = props;
    const fieldProps = {
        InputProps: { inputComponent: NumberField, disableUnderline: disabled },
        ...rest,
    };
    return <TextField {...fieldProps} />;
};

CustomNumberField.defaultProps = {
    value: 0,
    name: "",
    disabled: false,
};

CustomNumberField.propTypes = {
    storeName: PropTypes.string.isRequired,
    name: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(CustomNumberField);
